import { request } from './index'
import $store from '@/store/index'
import { updateBackup } from './mediaHub'
import Qs from 'qs'
const protocol = window.location.protocol

export const searchInit = (searchUrl) => {
  return request({
    url: `${protocol}//${searchUrl}/route-mma/tvu-search/base/init`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Search Init'
  })
}

export const searchGroupIdList = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/user/groupIdListByUserId`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Group List'
  })
}

export const searchCheckAdmin = (objectId) => {
  const data = {
    userId: $store.state.userInfo.id,
    objectId
  }
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/checkObjectAdmin`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Check Object Admin'
  })
}

export const searchCheckFeature = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/source/checkObjectFeature`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Check Object Feature'
  })
}

export const searchTemplateList = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/v2/file/templateList`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Template List'
  })
}

export const searchPermission = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/user/permission`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Permission'
  })
}

// export const newestSlugsByObjectIds = (data) => {
//   return request({
//     url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/newestSlugsByObjectIds`,
//     method: 'POST',
//     data,
//     disabledErrorTips: true
//   })
// }

export const newestSlugsByObjectIds = (params) => {
  const _params = Qs.stringify(params, { indices: false })
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/search/v2/event/latest?${_params}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Latest Slugs'
  })
}

export const entitlementGroupObjectInfo = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/source/entitlementGroupObjectInfo`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Group Object Info'
  })
}

export const entitlementSourceObjectId = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/source/entitlementSourceObjectId`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Source Object ID'
  })
}

export const entitlementSourceObjectInfoPage = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/source/entitlementSourceObjectInfoPage`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Source Object Page'
  })
}

export const searchUpdateObject = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/updateObject`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Object'
  })
}

export const searchObjectDeviceInfo = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/objectDeviceInfo`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Device Info'
  })
}

export const searchDeviceInfo = (deviceId) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/device/deviceInfo`,
    method: 'POST',
    data: [deviceId],
    disabledErrorTips: true,
    notifyTitle: 'Search Device Info'
  })
}

export const searchToken = () => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/token`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Source Token'
  })
}

export const searchScanInfo = () => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/token/scan/info`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Scan Info'
  })
}

export const searchSourceList = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/sourceList`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Source List'
  })
}

export const searchOccupiedSourceList = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/occupiedSourceList`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Occupied Sources'
  })
}

// export const searchNdiSourceList = () => {
//   return request({
//     url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/source/ndiSourceList`,
//     method: 'GET',
//     disabledErrorTips: true
//   })
// }

export const searchPort = () => {
  return request({
    url: `${protocol}//${$store.state.initConfig.gatewayUrl}/domain-port/allocatePort`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Allocate Port'
  })
}

export const getDisaster = (objectId) => {
  return request({
    url: `${protocol}//${$store.state.initConfig.gatewayUrl}/workflow-engine/getAutoFailoverSetting?objectId=${objectId}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Failover Setting'
  })
}

export const addDisaster = (data) => {
  return request({
    url: `${protocol}//${$store.state.initConfig.gatewayUrl}/workflow-engine/setAutoFailoverSetting`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Add Failover Setting'
  })
}

export const updateDisaster = (data) => {
  if (data.objectId) {
    // 通知MH更新了备用源 source属性
    updateBackup({
      primaryObjectId: data.objectId,
      backupObjectId: data.objectRelationId
    })
  }
  return request({
    url: `${protocol}//${$store.state.initConfig.gatewayUrl}/workflow-engine/updateAutoFailoverSetting`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Failover Setting'
  })
}

export const searchUnLinkObject = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/unLinkObject`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Unlink Object'
  })
}

export const searchUpdateExt = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/updateExt`,
    method: 'POST',
    data,
    notifyTitle: 'Update Source Ext'
  })
}

export const searchIdentify = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/identifyProtocol`,
    method: 'GET',
    params: data,
    disabledErrorTips: true,
    notifyTitle: 'Identify Protocol'
  })
}

export const searchAddExt = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/addExt`,
    method: 'POST',
    data,
    notifyTitle: 'Add Source Ext'
  })
}

export const searchBatchAddExt = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/batchAddExt`,
    method: 'POST',
    data,
    notifyTitle: 'Batch Add Ext'
  })
}

export const searchAssignDevice = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/source/assignDevice`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Assign Device'
  })
}

export const searchBatchAssignDevice = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/batchCreateObject`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Batch Create Object'
  })
}

export const searchPhFileByPath = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/media/getPhFileByPath`,
    method: 'GET',
    params: data,
    disabledErrorTips: true,
    notifyTitle: 'Get File By Path'
  })
}

export const searchByTime = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/v2/file/bytime`,
    method: 'GET',
    params: data,
    disabledErrorTips: true,
    notifyTitle: 'Search By Time'
  })
}

export const detailedInfo = (slugId) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/detailedInfo?slugId=${slugId}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Slug Detail'
  })
}

export const updateSlug = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/update`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Slug'
  })
}

export const getFeatureInfo = (objectId) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/deriveFeatureInfo?objectId=${objectId}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Feature Info'
  })
}

export const getFeatureList = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/objectFeatureList`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Feature List'
  })
}

export const getObjectTagList = (data) => {
  return request({
    url: `${$store.state.initConfig.objectUIPath}/object/tagList`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Tag List'
  })
}

export const searchEventInfo = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/info`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Event Info'
  })
}

export const mapSlug = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/getMapping`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Slug Mapping'
  })
}

export const saveMapSlug = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/saveMapping`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Save Slug Mapping'
  })
}

export const chooseSlug = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/choose`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Choose Slug'
  })
}

export const importExcls = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/importExcls`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Import Excel'
  })
}

export const importSlug = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/importProcess`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Import Slug'
  })
}

export const exportTemplate = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/exportTemplate`,
    method: 'GET',
    disabledErrorTips: true,
    headers: {
      responseType: 'blob'
    },
    notifyTitle: 'Export Template'
  })
}

export const exportSlug = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/slug/export`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    headers: {
      responseType: 'blob'
    },
    notifyTitle: 'Export Slug'
  })
}

export const templateSelectedInfo = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/selectedInfo`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Selected Template'
  })
}

export const templateSelectedId = (id) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/selected?templateId=${id}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Select Template'
  })
}

export const deleteTemplate = (id) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/delete?id=${id}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Delete Template'
  })
}

export const templateList = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/list?type=1`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Template List'
  })
}

export const newFilterTemplateList = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/list?type=4`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Filter Templates'
  })
}

export const saveTemplate = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/save`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Save Template'
  })
}

export const updateTemplate = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/update`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Template'
  })
}

export const accessTemplateList = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/share/template/list?type=5`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Access Templates'
  })
}

export const convertRecordedInfo = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/source/convertRecordedInfo`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Convert Recorded Info'
  })
}

export const getCustomTag = () => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/tag/customList?type=1`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Custom Tags'
  })
}

export const getEmailList = (data) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/user/listAllUser`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get User List'
  })
}

export const searchRtilInfo = (sourceId) => {
  return request({
    url: `${protocol}//${$store.state.operateObject.searchUrl}/route-mma/tvu-search/device/rtilInfo`,
    method: 'POST',
    data: { xid: sourceId },
    disabledErrorTips: true,
    notifyTitle: 'Get RTIL Info'
  })
}

export const searchObjectTag = (data) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/metadataproto/MetadataUploader.UpdateObjectTag`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Object Tag'
  })
}

export const searchObjectAttr = (data) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/metadataproto/MetadataUploader.UpdateObjectAttr`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Object Attr'
  })
}

export const searchObjectSuggestion = (data) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/search/v1/i/objecttagsuggestion`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Tag Suggestions'
  })
}

export const autocompleteV2 = (query) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/search/v2/autocomplete?cityName=${query}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Autocomplete Search'
  })
}

// export const location = (geo) => {
//   const { latitude, longitude } = geo
//   return request({
//     url: `${$store.state.operateObject.geoUrl}/geoservice/location?lat=${latitude}&lng=${longitude}&whiteListKey=tvu_geo_white_list_`,
//     method: 'GET'
//   })
// }

export const searchObjectInfo = (objectIds, needFields) => {
  const date = new Date().getTime()
  const data = {
    query: '',
    pageNum: 1,
    pageSize: 999,
    sort: 1,
    tsrange: {
      startTime: date - 3 * 12 * 30 * 24 * 60 * 60 * 1000,
      endTime: 9999999999999
    },
    filters: {
      objectIds
    },
    needFields,
    userId: 'OTE3NGU4OTYxZTVlNjllODFjOWZkOWRiZDQ0YjBlNWI='
  }
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/search/v1/i/object`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Get Object Info'
  })
}

export const getNdiList = (userId) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/uds/resource?userId=${userId}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get NDI List'
  })
}

export const getObjectAttr = (objectIds, attr) => {
  const params = Qs.stringify({ objectIds, attrName: `attributes.${attr.join('.')}` }, { indices: false })
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/objectd/v1/attr?${params}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Object Attr'
  })
}

export const updateObjectAttr = (data) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/objectd/v1/attr`,
    method: 'PUT',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Update Object Attr'
  })
}

export const getSlugFile = (slugObjectId) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/search/v2/event/recordings?eventObjectId=${slugObjectId}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Slug Files'
  })
}

export const getSlugInfoList = (params) => {
  const _params = Qs.stringify(params, { indices: false })
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/search/v2/event?${_params}`,
    method: 'GET',
    disabledErrorTips: true,
    notifyTitle: 'Get Slug List'
  })
}

export const queryMetaData = (data) => {
  return request({
    url: `${$store.state.operateObject.baseUrl}/api/objectd/v1/query`,
    method: 'POST',
    data,
    disabledErrorTips: true,
    notifyTitle: 'Query Metadata'
  })
}
